// extracted by mini-css-extract-plugin
export var container = "StrengthsSection-module--container--2nZOi";
export var title = "StrengthsSection-module--title--186SB";
export var underline = "StrengthsSection-module--underline--1rpZd";
export var strong = "StrengthsSection-module--strong--3z6lB";
export var boxContainer = "StrengthsSection-module--box-container--mkUfc";
export var box = "StrengthsSection-module--box--YfdgA";
export var boxLabel = "StrengthsSection-module--box-label--3KXMx";
export var boxParagraph = "StrengthsSection-module--box-paragraph--21zeT";